var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmazonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pexels-italo-melo-2379004",
    x: -20,
    y: -16,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#333",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#pexels-italo-melo-2379004)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "pexels-italo-melo-2379004-2",
    "data-name": "pexels-italo-melo-2379004",
    width: 32,
    height: 32,
    rx: 10,
    fill: "#feb730"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_131",
    "data-name": "Mask Group 131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M.06,24.037c.1-.155.249-.165.464-.029A31,31,0,0,0,16.358,28.23,31.339,31.339,0,0,0,27.625,26.1l.421-.187c.184-.08.312-.133.391-.173a.537.537,0,0,1,.7.173c.16.232.12.448-.16.64-.341.253-.8.547-1.342.872a21.641,21.641,0,0,1-5.582,2.3,23.5,23.5,0,0,1-14.608-.769A23.85,23.85,0,0,1,.2,24.493.4.4,0,0,1,0,24.2a.289.289,0,0,1,.067-.173Zm8.757-8.294a5.862,5.862,0,0,1,.992-3.437,6.1,6.1,0,0,1,2.721-2.154,14.754,14.754,0,0,1,3.884-.96c.52-.061,1.377-.137,2.561-.232V8.466a5.344,5.344,0,0,0-.4-2.5A2.184,2.184,0,0,0,16.655,5.1h-.243a3.2,3.2,0,0,0-1.662.614,2.416,2.416,0,0,0-.9,1.462.748.748,0,0,1-.58.68L9.908,7.432c-.331-.08-.5-.24-.5-.52a.817.817,0,0,1,.029-.2,5.608,5.608,0,0,1,2.428-3.842,9.334,9.334,0,0,1,4.522-1.4h.72A7.4,7.4,0,0,1,22.3,3.191c.181.2.36.4.541.64a3.41,3.41,0,0,1,.377.6,2.558,2.558,0,0,1,.26.76c.08.339.141.56.181.68a3.842,3.842,0,0,1,.1.82c.013.418.027.658.027.738v7.043A4.362,4.362,0,0,0,24,15.855a3.173,3.173,0,0,0,.421.9l.68.9a.909.909,0,0,1,.181.48.513.513,0,0,1-.24.419c-1.6,1.4-2.481,2.161-2.619,2.281a.779.779,0,0,1-.84.06,8.086,8.086,0,0,1-.7-.662l-.414-.462q-.219-.274-.423-.56l-.4-.58a7.156,7.156,0,0,1-3.2,2.221,8.43,8.43,0,0,1-2.441.3,5.121,5.121,0,0,1-3.682-1.379,5.167,5.167,0,0,1-1.441-3.922l-.067-.1Zm5.007-.584a2.76,2.76,0,0,0,.566,1.819,1.917,1.917,0,0,0,1.54.683,2.025,2.025,0,0,0,.26-.027,1.5,1.5,0,0,1,.221-.031,2.994,2.994,0,0,0,1.9-1.571,4.222,4.222,0,0,0,.48-1.214,5.244,5.244,0,0,0,.181-1.067c.02-.26.02-.72.02-1.34v-.72a10.317,10.317,0,0,0-2.561.24,3.126,3.126,0,0,0-2.561,3.241l-.047-.027Zm12.221,9.373a.956.956,0,0,1,.176-.227,4.764,4.764,0,0,1,1.4-.667,10.8,10.8,0,0,1,2.15-.32,1.773,1.773,0,0,1,.547.04c.867.08,1.4.224,1.563.44a.924.924,0,0,1,.12.52v.2a6.672,6.672,0,0,1-.553,2.4,5.807,5.807,0,0,1-1.542,2.241.438.438,0,0,1-.262.12.311.311,0,0,1-.12-.016c-.12-.059-.143-.16-.085-.32a10.944,10.944,0,0,0,1.075-3.521.761.761,0,0,0-.116-.459c-.193-.221-.734-.343-1.633-.343-.324,0-.711.021-1.16.061-.484.06-.934.12-1.334.181a.353.353,0,0,1-.24-.059c-.04-.04-.048-.063-.027-.1a.221.221,0,0,1,.027-.084v-.08Z",
    transform: "translate(-0.003 -0.007)",
    fill: "#feb730"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonIcon);
export default __webpack_public_path__ + "static/media/amazonIcon.a9bd7eb9c30c45e0c9e545c6f21403b7.svg";
export { ForwardRef as ReactComponent };